import React, {Component} from 'react';
import { graphql, gql , compose} from 'react-apollo'
import {  /* Button ,Col, Row, Card, Icon, */ Spin } from 'antd'
// import Image from './Image'


class PostFb extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: false,
            failed: false,
            loading: false,
            button: 'Share to Facebook',
            icon: 'share-alt'
        }
    }
    handleShare = () => {
         this.setState({
            loading: true,
            button: 'Sharing',
            icon: ''
        })
        this.props.postFB({
            variables: {
                bib: parseInt(this.props.bib, 10),
                slug: this.props.event.slug
            }
        }).then(res => res.data.postFb)
        .then(val => {
            if(val[0]){
                console.log('shared')
                this.setState({
                    status: true,
                    loading: false,
                    button: 'Shared',
                    icon: 'check'
                })
            } else {
                console.log('falied')
                this.setState({
                    failed: true
                })
            }
        })
    }
    componentWillMount = () => {
        this.handleShare()
    }

    render() {
        if(!this.state.status) {
            return <Spin style={{marginTop: 20}}/>
        }
        if(!this.props.data.times) {
                return <div>loading</div>
            }
        return (
            <div>
                {this.state.failed?
                    // <div>
                    //     <Row type="flex" justify="start">
                    //         <Col span={24}>
                    //             <Button type="primary" size="large" loading={this.state.loading} onClick={this.handleShare}>
                    //                 <Icon type={this.state.icon}/> {this.state.button}
                    //             </Button>
                    //         </Col>
                    //     </Row>
                    //     <Row type="flex" justify="center">
                    //     {this.props.data.times.filter(value => !value.eSlip).map((time, index) => (
                    //         <Col key={index} md={{span:12}}>
                    //             <Card style={{margin: 10}}>
                    //                 <Image link={time.link} />
                    //                 <div className="custom-card">
                    //                     <h3>{time.CheckPointName}</h3>
                    //                 </div>
                    //             </Card>
                    //         </Col>
                    //     ))}
                    //     </Row>
                    // </div>
                    <div></div>
                    :
                    <div className="wrap-thank" style={{marginBottom: 20}}>
                        <h1>ระบบได้โพสเช็คพอยท์บนเฟสบุ๊คของท่านเรียบร้อยแล้ว</h1>
                    </div>
                }
            </div>
        );
    }
}

const withPost = gql `
mutation postFB( $bib: Int!, $slug: String!){
  postFb(
    recode:{
      bib: $bib,
      slug: $slug
    }
  )
}
`
const withQuery = gql`
query findTime($bibNumber: Float!, $event:String!){
  times(filter:{
    bibNumber:$bibNumber,
    event:$event
  }){
    _id,
    link
  }
}
`
export default compose(
    graphql(withQuery,{
        options:(props) => ({
            variables: {
                bibNumber: props.bib,
                event: props.event.event
            }
        })
    }),
    graphql(withPost, {
        name: 'postFB'
    })
)(PostFb)


// WEBPACK FOOTER //
// ./src/Login/Component/PostFb.js